export function createFpsOverlay(document) {
 const element=document.createElement('div');
 element.className='mission-fps';
 element.setAttribute('role','status');
 element.setAttribute('aria-live','off');
 document.body.append(element);
 let state='idle',lang='fr';
 function show(text){if(element.textContent!==text)element.textContent=text;element.setAttribute('aria-label',text);}
 function status(){show(state==='idle'?(lang==='en'?'FPS idle':'FPS repos'):state==='pause'?'FPS pause':'FPS —');}
 status();
 return {
  wake(){state='active';status();},
  pause(){state='pause';status();},
  idle(){state='idle';status();},
  setLanguage(value){lang=value==='en'?'en':'fr';if(state!=='active')status();},
  sample(value){if(state==='active'&&Number.isFinite(value?.fps)&&value.fps>0)show(value.fps<.05?'<0.1 FPS':`${value.fps.toFixed(1)} FPS`);}
 };
}
